// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20.5006 0.585693V19.4999H1.5864L20.5006 0.585693ZM20.5006 20.9999V22.9999L1.50098 22.9999L1.50098 20.9999L20.5006 20.9999Z"}}]};

const SharpnessFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'sharpness-filled',
    ref,
    icon: element,
  },
));

SharpnessFilledIcon.displayName = 'SharpnessFilledIcon';

export default SharpnessFilledIcon;
